import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";
import {
  generateOptions,
  tempToColor,
  timestampConverter,
} from "../utils/helpers";
import { useState } from "react";
function DailyForecastChart({ tempColor, daily }) {
  const [option, setOption] = useState("temp");
  if (daily === undefined) return;
  const { key, name, unit, color } = generateOptions(option);
  const newDaily = daily.map((item) => {
    const newItem = { ...item, label: timestampConverter(item.dt) };
    return newItem;
  });
  return (
    <div
      style={{
        width: "90%",
        margin: "auto",
        transition: ".5s",
        backgroundColor: `${tempToColor(tempColor)}`,
        padding: "20px",
        borderRadius: "20px",
      }}
    >
      <h3>8 Day Forecast</h3>
      <ResponsiveContainer width="100%" height={300}>
        <AreaChart data={newDaily}>
          <XAxis dataKey="label"></XAxis>
          <YAxis></YAxis>
          <CartesianGrid strokeDasharray="4"></CartesianGrid>
          <Tooltip></Tooltip>
          {option === "temp" ? (
            <>
              <Area
                type="monotone"
                fill={color}
                dataKey="temp.max"
                strokeWidth={2}
                name={`${name} (maximum)`}
                unit={unit}
              ></Area>
              <Area
                type="monotone"
                fill={color}
                dataKey="temp.morn"
                strokeWidth={2}
                name={`${name} (morning)`}
                unit={unit}
              ></Area>
              <Area
                type="monotone"
                fill={color}
                dataKey="temp.day"
                strokeWidth={2}
                name={`${name} (day)`}
                unit={unit}
              ></Area>
              <Area
                type="monotone"
                fill={color}
                dataKey="temp.eve"
                strokeWidth={2}
                name={`${name} (evening)`}
                unit={unit}
              ></Area>
              <Area
                type="monotone"
                fill={color}
                dataKey="temp.night"
                strokeWidth={2}
                name={`${name} (night)`}
                unit={unit}
              ></Area>
              <Area
                type="monotone"
                fill={color}
                dataKey="temp.min"
                strokeWidth={2}
                name={`${name} (minimum)`}
                unit={unit}
              ></Area>
            </>
          ) : (
            <Area
              type="monotone"
              fill={color}
              dataKey={key}
              strokeWidth={2}
              name={name}
              unit={unit}
            ></Area>
          )}
        </AreaChart>
      </ResponsiveContainer>
      <form>
        <label>
          forecast by
          <select value={option} onChange={(e) => setOption(e.target.value)}>
            <option value="temp">temperature(celsius)</option>
            <option value="clouds">cloudiness(%)</option>
            <option value="humidity">humidity(%)</option>
            <option value="pressure">pressure(hPa)</option>
          </select>
        </label>
      </form>
    </div>
  );
}

export default DailyForecastChart;
